module.exports = __webpack_public_path__ + "static/media/0018.1a060b90.png";